/**
 * Application footer displaying the copyright notice.
 *
 * @module components/common/Footer
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import FooterStyle from './Footer';

/**
 * Footer functional component.
 *
 * This component renders the footer of the application, including a copyright notice.
 * It uses Material-UI components for styling and layout.
 *
 * Dependencies:
 * - makeStyles: A hook that generates CSS classes for styling the component.
 * - Paper: A Material-UI component used as a container to display the content with background styling.
 * - Typography: A Material-UI component used to display the text in the desired format.
 *
 * Styling:
 * - The styling for the component is defined using the FooterStyle function and applied via the makeStyles hook.
 * - Contains custom styles for the root container and the copyright text.
 *
 * Content:
 * - Displays a copyright notice specific to iLearnCC with the year as "2022".
 */
const Footer = () => {
    const useStyles = makeStyles((theme) => FooterStyle(theme));
    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            <Typography className={classes.copyright} variant="body2">
                Copyright &copy; iLearnCC 2022 - {(new Date()).getFullYear()}. All rights reserved
            </Typography>
        </Paper>
    );
};

export default Footer;
